// src/utils/translationUtils.js

export const flattenTranslations = (obj, parentKey = "", separator = ".") => {
  const flattened = Object.keys(obj).reduce((acc, key) => {
    const newKey = parentKey ? `${parentKey}${separator}${key}` : key;
    const value = obj[key];
    // Preserve arrays as leaf values — do NOT flatten into numeric keys.
    // This prevents [{}] from becoming {"0":{}} after unflatten.
    if (Array.isArray(value)) {
      acc[newKey] = value;
    } else if (typeof value === "object" && value !== null) {
      Object.assign(acc, flattenTranslations(value, newKey, separator));
    } else {
      acc[newKey] = value;
    }
    return acc;
  }, {});
  return flattened;
};

export const unflattenTranslations = (obj, separator = ".") => {
  const result = {};
  Object.keys(obj).forEach((flatKey) => {
    const keys = flatKey.split(separator);
    keys.reduce((acc, key, index) => {
      if (index === keys.length - 1) {
        acc[key] = obj[flatKey];
      } else {
        if (!acc[key]) acc[key] = {};
      }
      return acc[key];
    }, result);
  });
  return result;
};
